import getFullNameWithTitle from './getFullNameWithTitle.js';

export default userId => participants =>
  participants
    .filter(participant => participant.userId !== userId)
    .map(participant => getFullNameWithTitle(participant))
    .join('; ');
